import { render } from "./NamedAddInput.vue?vue&type=template&id=ce08bea6"
import script from "./NamedAddInput.vue?vue&type=script&lang=js"
export * from "./NamedAddInput.vue?vue&type=script&lang=js"

import "./NamedAddInput.vue?vue&type=style&index=0&id=ce08bea6&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__